import React from 'react'
import classNames from 'classnames'
import { Button } from '@/components/ui'
import { LandingAnimation } from '../../../../components/composed/landingBlocks/LandingAnimation'
import { LANDING_ANIMATION } from '../../../../components/composed/landingBlocks/LandingAnimation/constants'
import { messages } from './messages'
import type { LandingLoanDiscountProps } from './types'
import './styles.scss'

export const LandingLoanDiscount: React.FC<LandingLoanDiscountProps> = ({ className, withAnimation, onClickGetDiscountButton }) => {
  return (
    <section className={classNames('landingLoanDiscount', className)}>
      <div className="page-wrapper">
        <LandingAnimation desktopTargetStyles={LANDING_ANIMATION.fadeUp} isDisabled={!withAnimation}>
          <div className="landingLoanDiscount__wrapper">
            <h2 className="landingLoanDiscount__title">{messages.title}</h2>
            <p className="landingLoanDiscount__description">{messages.description}</p>
            <Button className="landingLoanDiscount__getDiscount" modifiers={['green']} onClick={onClickGetDiscountButton}>
              {messages.button.getDiscount}
            </Button>
          </div>
        </LandingAnimation>
      </div>
    </section>
  )
}
